import {
    ApiContentSection,
    ApiPlaylist,
    ApiSectionType,
} from '@storefronts/common-types'
import { useEffect, useState } from 'react'
import { getPlaylist } from '../../../../../api'
import { StorefrontPlaylist } from '../../../../context/fullScreenVideoContext'
import { SectionContainer, SectionTitle } from '../Shared'
import Carousel from './Carousel'

type CarouselContentSection = Extract<
    ApiContentSection,
    { type: ApiSectionType.VIDEO_CAROUSEL }
>

export const VideoCarousel: React.FC<{
    section: CarouselContentSection
}> = ({ section }) => {
    const [fetched, setFetched] = useState<{
        hash: string
        playlist: ApiPlaylist
    } | null>(null)

    useEffect(() => {
        if (section.playlist) return
        if (!section.playlistHash) return
        let cancelled = false
        getPlaylist(section.playlistHash).then((playlist) => {
            if (!cancelled) setFetched({ hash: section.playlistHash, playlist })
        })
        return () => {
            cancelled = true
        }
    }, [section.playlist, section.playlistHash])

    const playlist: StorefrontPlaylist | null =
        section.playlist ??
        (fetched?.hash === section.playlistHash ? fetched.playlist : null)

    if (!playlist) return null

    return (
        <SectionContainer>
            {section.sectionTitle && (
                <SectionTitle isHorizontalScroll>
                    {section.sectionTitle}
                </SectionTitle>
            )}
            <Carousel playlist={playlist} />
        </SectionContainer>
    )
}
